import { PdfAction } from '@app/libs/reactPdfJs/store/actions';
import {
  EDITING_DOCUMENT__SET_IS_NEW_EDITING_DOCUMENT,
  PDF_CLEAR_ALL_STATE,
} from '@app/store/actionTypes';
import { EditingDocumentAction } from '@app/store/editingDocument/actions';

type EditingDocumentIsNewEditingDocument = boolean;

const initialState: EditingDocumentIsNewEditingDocument = false;

export default function reducer(
  state: EditingDocumentIsNewEditingDocument = initialState,
  action: EditingDocumentAction | PdfAction
) {
  switch (action.type) {
    case EDITING_DOCUMENT__SET_IS_NEW_EDITING_DOCUMENT:
      return true;
    case PDF_CLEAR_ALL_STATE:
      return initialState;
    default:
      return state;
  }
}
